var map = {
	"./Portfolio": 6926,
	"./Portfolio.css": 6907,
	"./Portfolio.tsx": 6926,
	"./PortfolioAPI": 9048,
	"./PortfolioAPI.tsx": 9048,
	"./PortfolioInterface": 3505,
	"./PortfolioInterface.tsx": 3505,
	"./likedProjectsReducer": 481,
	"./likedProjectsReducer.ts": 481,
	"./portfolio-image/99 Back End Tech Challenge/1.jpg": 2824,
	"./portfolio-image/99 Back End Tech Challenge/2.jpg": 7575,
	"./portfolio-image/AI Live Shopping/1.mp4": 8664,
	"./portfolio-image/AI Live Shopping/2.mp4": 1519,
	"./portfolio-image/BINUSMAYA LMS Website/1.jpg": 8319,
	"./portfolio-image/BINUSMAYA LMS Website/2.jpg": 4704,
	"./portfolio-image/BINUSMAYA LMS Website/3.jpg": 5837,
	"./portfolio-image/BINUSMAYA LMS Website/4.jpg": 1078,
	"./portfolio-image/Deacon AI Product Photography/1.jpg": 7543,
	"./portfolio-image/Eksotika Prima Rub Oil Supplier Website/1.jpg": 3091,
	"./portfolio-image/Eksotika Prima Rub Oil Supplier Website/2.jpg": 8612,
	"./portfolio-image/Eksotika Prima Rub Oil Supplier Website/3.jpg": 2337,
	"./portfolio-image/Gibapp Website/1.jpg": 5267,
	"./portfolio-image/Gibapp Website/2.jpg": 5556,
	"./portfolio-image/Jasger Mobile App/1.jpg": 6504,
	"./portfolio-image/Jasger Mobile App/2.jpg": 4903,
	"./portfolio-image/Jasger Mobile App/3.jpg": 1066,
	"./portfolio-image/Jasger Mobile App/4.jpg": 1753,
	"./portfolio-image/Job Sprint API/1.jpg": 840,
	"./portfolio-image/Job Sprint API/2.jpg": 9239,
	"./portfolio-image/KSN Informatika 2021 Provincial Level/1.jpg": 7684,
	"./portfolio-image/Karya Asuh/1.jpg": 6968,
	"./portfolio-image/Karya Asuh/2.jpg": 9924,
	"./portfolio-image/Karya Asuh/3.jpg": 6730,
	"./portfolio-image/Medicare Project Website/1.jpg": 2371,
	"./portfolio-image/Medicare Project Website/2.jpg": 6148,
	"./portfolio-image/Medicare Project Website/3.jpg": 9745,
	"./portfolio-image/Movie NET/1.jpg": 6946,
	"./portfolio-image/Movie NET/2.jpg": 5901,
	"./portfolio-image/Movie NET/3.jpg": 336,
	"./portfolio-image/My Portfolio Website/1.jpg": 8242,
	"./portfolio-image/My Portfolio Website/2.jpg": 1149,
	"./portfolio-image/My Portfolio Website/3.jpg": 6576,
	"./portfolio-image/My Portfolio Website/4.jpg": 8227,
	"./portfolio-image/Rumah123.com/1.jpg": 3359,
	"./portfolio-image/Rumah123.com/2.jpg": 8400,
	"./portfolio-image/Rumah123.com/3.jpg": 5501,
	"./portfolio-image/Rumah123.com/4.jpg": 2150,
	"./portfolio-image/Secure Auth With Golang/1.jpg": 7646,
	"./portfolio-image/Secure Auth With Golang/2.jpg": 3593,
	"./portfolio-image/Secure Auth With Golang/3.jpg": 1980,
	"./portfolio-image/convert all image to JPG.bat": 295,
	"./section-2-bg.jpg": 5220,
	"./section-2-bg.png": 2256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6823;